import Product from "./Product";
import { getCartItems, postCartItems, removeAllCartItems, } from "../services/cartService";
var Cart = /** @class */ (function () {
    function Cart() {
        this._products = [];
        this.load();
    }
    Cart.prototype.showAll = function () {
        return this._products;
    };
    Cart.prototype.load = function () {
        var _this = this;
        var loadData = getCartItems();
        if (loadData) {
            loadData.forEach(function (element) {
                var product = new Product();
                product.create(element.item);
                _this._products.push({
                    item: product,
                    amount: element.amount,
                });
            });
        }
    };
    Cart.prototype.getCartItemById = function (id) {
        return this._products.filter(function (p) { return p.item.id == id; })[0];
    };
    Cart.prototype.add = function (product) {
        var itemSearch = this._products.filter(function (p) { return p.item.id == product.id; });
        if (itemSearch.length === 0) {
            this._products.push({
                item: product,
                amount: 1,
            });
        }
        else {
            itemSearch[0].amount++;
        }
        postCartItems(this._products);
    };
    Cart.prototype.substract = function (id) {
        var itemSearch = this._products.filter(function (p) { return p.item.id == id; });
        if (itemSearch.length != 0) {
            if (itemSearch[0].amount > 1) {
                itemSearch[0].amount--;
            }
            else {
                this._products = this._products.filter(function (p) { return p.item.id != id; });
            }
            postCartItems(this._products);
        }
    };
    Cart.prototype.remove = function (id) {
        this._products = this._products.filter(function (p) { return p.item.id != id; });
        postCartItems(this._products);
    };
    Cart.prototype.clearAll = function () {
        this._products = [];
        removeAllCartItems();
    };
    return Cart;
}());
export default Cart;
